module.exports = __webpack_public_path__ + "static/media/facebook.f0ba615a.svg";